import React from 'react';
import usePlatform from 'shared/hooks/use-platform';
import MobileStub from 'ud-ui/components/stubs/mobile-stub';
import TabletStub from 'ud-ui/components/stubs/tablet-stub';
import { useIsAdmin } from 'shared/hooks/use-is-admin';

export type MobileGuardProps = {
  children: React.ReactNode;
};

/**
 * MobileGuard renders children only when viewport width >= tablet breakpoint (default 834).
 * Phones (<=500) see MobileStub; tablets (between 500 and 834) see TabletStub.
 */
const MobileGuard: React.FC<MobileGuardProps> = ({ children }) => {
  const isAdmin = useIsAdmin();
  const { isMobile, isTablet, isDesktop, isLandscape } = usePlatform();

  if (isAdmin) {
    return <>{children}</>;
  }

  if (isMobile) {
    return <MobileStub isLandscape={isLandscape} />;
  }

  if (isTablet) {
    return <TabletStub isLandscape={isLandscape} />;
  }

  if (!isDesktop) {
    // Fallback (shouldn't happen, but keep previous behavior)
    return <MobileStub />;
  }

  return <>{children}</>;
};

export default MobileGuard;
